export default __webpack_public_path__ + "static/media/pic_lab.644644e9.png";